module.exports = __webpack_public_path__ + "static/media/tech01.8dd19b3c.png";